import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import intagrtionsBgImage from '@assets/images/integrations/integration-popup-image.jpg';
import { IntegrationItem } from '@shared/models/integrations/integrations.model';
import { useNavigate } from 'react-router-dom';

const IntegrationsPopopContent: React.FC<{ item: IntegrationItem | null }> = ({
  item
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/contact-us?category=integrations&integrationName=${item?.name}`);
  };

  return (
    <div className="flex w-full h-[600px]">
      <div
        className="w-[50%] h-full absolute left-0 top-0 flex justify-center items-center"
        style={{
          background: `url(${intagrtionsBgImage}) no-repeat center center`,
          backgroundSize: 'cover'
        }}
      >
        <img
          src={item?.image}
          alt={'name'}
          className="w-[490px] h-[450px] max-lg-xl:w-[300px] max-lg-xl:h-[260px] rounded-[18px] mb-4"
        />
      </div>

      <div className="w-[50%] h-full p-[100px] absolute right-0 top-0 flex flex-col justify-center">
        <h2 className="font-medium text-[60px] mb-10  max-lg-xl:text-[40px]">
          {t('integrations_popup_title')}
        </h2>
        <p className="font-light text-[20px] mb-5  max-lg-xl:text-[16px]">
          {item?.description || t('integrations_popup_description')}
        </p>
        <Button
          variant="contained"
          color="primary"
          sx={{ width: '100%', maxWidth: '100%', marginTop: '20px' }}
          onClick={handleClick}
        >
          {t('integrations_popup_button')}
        </Button>
      </div>
    </div>
  );
};

export default IntegrationsPopopContent;
